exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#hinweise[data-v-6fea9806]{width:100%}.attribut[data-v-6fea9806],.name[data-v-6fea9806],.parameter[data-v-6fea9806],.rueckgabetyp[data-v-6fea9806]{line-height:110%;margin-top:0;margin-bottom:5px;padding:10px;background-color:#dcdcdc}.parameterliste[data-v-6fea9806]{padding-left:40px;margin:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6fea9806","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Hinweise.vue
// module id = 14
// module chunks = 0